import { css } from 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
var Container = {
  base: css(["", ";"], function (props) {
    return props.isFluid && css(["margin:0px;"]);
  })
};
export default Container;